// extracted by mini-css-extract-plugin
export var blockedMessage = "_90-3";
export var blockedOverlay = "_90-1";
export var fadeIn = "_90-2";
export var hereLink = "_90-0";
export var slideUp = "_90-4";